    document.addEventListener('DOMContentLoaded', function() {
      if (window.customerHasTagGreenBanner) {
          const alreadyRedirectedData = localStorage.getItem('already_redirected');
          if (alreadyRedirectedData) {
            try {
              const redirectedInfo = JSON.parse(alreadyRedirectedData);
              const now = new Date().getTime();
              
              if (redirectedInfo.expiry && now < redirectedInfo.expiry) {
                console.log('Redirection déjà effectuée récemment');
                return;
              } else {
                localStorage.removeItem('already_redirected');
              }
            } catch (e) {
              localStorage.removeItem('already_redirected');
            }
          }
          
          const greenBannerData = localStorage.getItem('green_banner');
          if (!greenBannerData) {
            return;
          }
          
          try {
            const greenBannerValue = JSON.parse(greenBannerData);
            if (greenBannerValue && greenBannerValue.value) {
              const currentUrl = window.location.href;
              const targetUrl = greenBannerValue.value;
              try {
                const targetUrlObj = new URL(targetUrl);
                const isProductPage = targetUrlObj.pathname.includes('/products/');
                if (!isProductPage) {
                  console.log('URL cible n\'est pas une page de produit, annulation de la redirection');
                  localStorage.removeItem('green_banner'); 
                  return;
                }
              } catch (urlError) {
                console.error('URL cible invalide:', urlError);
                localStorage.removeItem('green_banner');
                return;
              }
              
              const currentUrlObj = new URL(currentUrl);
              const targetUrlObj = new URL(targetUrl);
              const isSamePath = currentUrlObj.origin + currentUrlObj.pathname === 
                                targetUrlObj.origin + targetUrlObj.pathname;

              if (isSamePath) {
                console.log('Déjà sur la page cible, annulation de la redirection');
                return;
              }

              if (greenBannerValue.expiry) {
                const now = new Date().getTime();
                if (now > greenBannerValue.expiry) {
                  localStorage.removeItem('green_banner');
                  return;
                }
              }
              
              const expiryDate = new Date();
              expiryDate.setHours(expiryDate.getHours() + 24);
              
              const redirectInfo = {
                redirected: true,
                expiry: expiryDate.getTime()
              };
              
              localStorage.setItem('already_redirected', JSON.stringify(redirectInfo));
              window.location.href = greenBannerValue.value;
            }
          } catch (e) {
            console.error('Erreur lors du parsing des données green_banner:', e);
            localStorage.removeItem('green_banner'); 
          }
     }
    });
